interface SurveyMonkeyConfig {
  surveyId: string;
  surveyUrl?: string;
}

class SurveyMonkeyService {
  private isServiceEnabled = false;
  private loadedSurveyId: string | null = null;

  enableService(): void {
    this.isServiceEnabled = true;
  }

  showSurvey(config?: SurveyMonkeyConfig): void {
    if (!this.isServiceEnabled) {
      return;
    }

    const surveyId = config?.surveyId;
    if (!surveyId) return;

    if (config?.surveyUrl) {
      this.openInNewTab(config.surveyUrl);
      return;
    }

    if (this.loadedSurveyId !== surveyId) {
      this.removeExistingScript();
      this.injectScript(surveyId, () => this.triggerDisplay());
      this.loadedSurveyId = surveyId;
    } else {
      this.triggerDisplay();
    }
  }

  private injectScript(surveyId: string, onLoad?: () => void): void {
    window.SMCX = window.SMCX || [];

    const script = document.createElement('script');
    script.id = 'smcx-sdk';
    script.type = 'text/javascript';
    script.async = true;
    script.src = `https://widget.surveymonkey.com/collect/website/js/${surveyId}.js`;
    if (onLoad) {
      script.onload = onLoad;
    }

    document.head.appendChild(script);
  }

  private removeExistingScript(): void {
    const existingScript = document.getElementById('smcx-sdk');
    if (existingScript) {
      existingScript.remove();
    }
  }

  private triggerDisplay(): void {
    setTimeout(() => {
      const SMCX = window.SMCX;
      if (SMCX && typeof SMCX.push === 'function') {
        SMCX.push(['showSurvey']);
        SMCX.push(['show']);
      }
    }, 100);
  }

  private openInNewTab(url: string): void {
    window.open(
      url,
      '_blank',
      'width=800,height=600,scrollbars=yes,resizable=yes',
    );
  }
}

declare global {
  interface Window {
    SMCX: any[];
  }
}

const surveyMonkeyService = new SurveyMonkeyService();

export default surveyMonkeyService;
